import axios from "axios";
import { reactAppAxios } from "../config/config";

const clienteAxios = axios.create({
  baseURL: reactAppAxios,
});

export default clienteAxios;
